import { Injectable } from '@angular/core';

import { FormArray, FormControl, FormGroup } from "@angular/forms";

/**
 * example :
 * https://stackblitz.com/edit/tests-price-grid?file=src%2Fapp%2Fapp.module.ts
 * example alternative:
 * https://stackblitz.com/edit/tests-price-grid-c1qu5l?file=src/app/app.component.ts
 */
@Injectable()
export class CostFormGetterService {

    public getTravellerPriceDetailGroup(costFormGroup: FormGroup, travellerId?: number, priceDetailId?: number, currency: string = "EUR"): FormGroup {
        const travellerPriceDetail: FormArray = costFormGroup.get("travellerPriceDetail") as FormArray;
        if(!priceDetailId){
            return this.generateEmptyTravellerPriceDetailGroup(travellerId, priceDetailId, currency);
        }
        const travellerPriceDetailFound: FormGroup = travellerPriceDetail.controls
            .find((travellerPriceDetailGroup: FormGroup) => {
                return travellerPriceDetailGroup.get('priceDetail').value === priceDetailId && travellerPriceDetailGroup.get('traveller').value === travellerId;
            }) as FormGroup;
        return travellerPriceDetailFound || this.generateEmptyTravellerPriceDetailGroup(travellerId, priceDetailId, currency);
    }

    public getTravellerTotalGroup(costFormGroup: FormGroup, travellerId: number): FormGroup {
        const travellerTotals: FormArray = costFormGroup.get('travellerTotal') as FormArray;
        return travellerTotals.controls
            .find((travellerTotal: FormGroup) => travellerTotal.get('id').value === travellerId) as FormGroup;
    }

    public generateEmptyTravellerPriceDetailGroup(travellerId?: number, priceDetailId?: number, currency: string = "EUR"): FormGroup {
        return new FormGroup({
            priceDetail: new FormControl(priceDetailId),
            traveller: new FormControl(travellerId),
            value: new FormControl(null),
            amount: new FormControl(null),
            currency: new FormControl(currency),
        });
    }
}